import Header from "./Header";
import Place from "./Place";
import User from "./User";
const components = [Header, Place, User];
const plugins = [];

const version = 1.0;

const install = (app) => {
  components.forEach((component) => {
    app.component(component.name, component);
  });
  plugins.forEach((plugin) => {
    app.use(plugin);
  });
};

export default {
  version,
  install,
};
